import { Button } from '@dsx-react/button';
import { useMessageFormatter } from '@dsx-react/i18n';
import { MdNavigateBefore } from '@dsx-react/icon';
import { Text } from '@dsx-react/text';
import { classNames } from '@dsx-react/util';
import { jsx, jsxs } from 'react/jsx-runtime';

var pagination$1 = "paginatin'";
var next$1 = "Starboard";
var previous$1 = "Port";
var pageOfPageCount$1 = "{page} o' {pageCount}";
var startToEndOutOfTotalResults$1 = "{start}-{end} out o' {totalCount, plural, =0 {0 parchments} one {1 parchment} other {{totalCount} parchments}}";
var enPT = {
	pagination: pagination$1,
	next: next$1,
	previous: previous$1,
	pageOfPageCount: pageOfPageCount$1,
	startToEndOutOfTotalResults: startToEndOutOfTotalResults$1
};

var pagination = "pagination";
var next = "Next";
var previous = "Previous";
var pageOfPageCount = "{page} of {pageCount}";
var startToEndOutOfTotalResults = "{start}-{end} out of {totalCount, plural, =0 {0 results} one {1 result} other {{totalCount} results}}";
var enUS = {
	pagination: pagination,
	next: next,
	previous: previous,
	pageOfPageCount: pageOfPageCount,
	startToEndOutOfTotalResults: startToEndOutOfTotalResults
};

const messages = {
  'en-US': enUS,
  'en-PT': enPT
};
var messages$1 = messages;

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Pagination-module_pagination__Qzvlc {\n  display: flex;\n  flex-flow: row wrap;\n  gap: var(--size-400);\n  align-items: center;\n}\n\n.Pagination-module_navigation__7rs6Y {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  gap: var(--size-200);\n}\n\n.Pagination-module_pages__9xUcK {\n  display: flex;\n  flex-flow: row nowrap;\n  border-radius: var(--border-radius-default);\n}\n\n.Pagination-module_pages__9xUcK.Pagination-module_default__-n0RZ.Pagination-module_initial__FDGUI {\n  background-color: var(--UNSAFE-button-default-background);\n}\n\n.Pagination-module_pages__9xUcK.Pagination-module_default__-n0RZ.Pagination-module_loading__ihyco > button {\n  border-radius: 0;\n}\n\n.Pagination-module_pages__9xUcK.Pagination-module_default__-n0RZ.Pagination-module_loading__ihyco > .Pagination-module_selected__eWQUu {\n  border-radius: var(--border-radius-default);\n}\n\n.Pagination-module_pages__9xUcK.Pagination-module_default__-n0RZ.Pagination-module_loading__ihyco > button:first-child {\n  border-top-left-radius: var(--border-radius-default);\n  border-bottom-left-radius: var(--border-radius-default);\n}\n\n.Pagination-module_pages__9xUcK.Pagination-module_default__-n0RZ.Pagination-module_loading__ihyco > button:last-child {\n  border-top-right-radius: var(--border-radius-default);\n  border-bottom-right-radius: var(--border-radius-default);\n}\n\n.Pagination-module_nav-only-count__LPmr7 {\n  margin: 0 var(--size-200);\n}";
var styles = {"pagination":"Pagination-module_pagination__Qzvlc","navigation":"Pagination-module_navigation__7rs6Y","pages":"Pagination-module_pages__9xUcK","default":"Pagination-module_default__-n0RZ","initial":"Pagination-module_initial__FDGUI","loading":"Pagination-module_loading__ihyco","selected":"Pagination-module_selected__eWQUu","nav-only-count":"Pagination-module_nav-only-count__LPmr7"};
styleInject(css_248z);

function Pagination(props) {
  const {
    page,
    pageSize,
    totalCount,
    onPageChange,
    layout = 'nav-only',
    loadingState = 'initial',
    variant = 'default',
    className: callerClassName,
    tag
  } = props;
  const className = classNames('dsx-component', styles['pagination'], callerClassName);
  const pagesClassName = classNames(styles['pages'], styles[loadingState]);
  const {
    formatMessage
  } = useMessageFormatter(messages$1);
  const isLoading = loadingState === 'loading';
  const isIconOnly = layout !== '9-slot-full';
  const buttonVariant = variant === 'default' ? 'default' : 'ui-control';
  const pageCount = Math.ceil(totalCount / pageSize);
  const start = Math.min(totalCount, page * pageSize + 1);
  const end = Math.min(totalCount, page * pageSize + pageSize);
  const summaryEl = /*#__PURE__*/jsx(Text, {
    children: formatMessage('startToEndOutOfTotalResults', {
      start,
      end,
      totalCount
    })
  });
  const pagesEls = layout === 'nav-only' ? /*#__PURE__*/jsx(Text, {
    className: styles['nav-only-count'],
    children: formatMessage('pageOfPageCount', {
      page: page + 1,
      pageCount
    })
  }) : /*#__PURE__*/jsx("div", {
    className: pagesClassName,
    children: pageRange(page, pageCount, layout).map((p, i) => p === '...' ? /*#__PURE__*/jsx(Button, {
      variant: buttonVariant,
      size: "small",
      disabled: true,
      children: "..."
    }, `ellipsis-${i}`) : p === page ? /*#__PURE__*/jsx(Button, {
      variant: "primary",
      size: "small",
      disabled: isLoading,
      className: styles['selected'],
      "aria-current": "page",
      [`data-dsx--pagination--page-${p}`]: tag,
      children: (p + 1).toLocaleString()
    }, p) : /*#__PURE__*/jsx(Button, {
      variant: buttonVariant,
      size: "small",
      disabled: isLoading,
      onClick: e => {
        e.preventDefault();
        onPageChange(p);
      },
      [`data-dsx--pagination--page-${p}`]: tag,
      children: (p + 1).toLocaleString()
    }, p))
  });
  return /*#__PURE__*/jsxs("nav", {
    className: className,
    "aria-label": formatMessage('pagination'),
    "data-dsx--pagination": tag,
    children: [/*#__PURE__*/jsxs("div", {
      className: styles['navigation'],
      children: [/*#__PURE__*/jsx(Button, {
        icon: MdNavigateBefore,
        iconOnly: isIconOnly,
        variant: buttonVariant,
        size: "small",
        disabled: isLoading || page === 0,
        onClick: e => {
          e.preventDefault();
          if (page > 0) {
            onPageChange(page - 1);
          }
        },
        "data-dsx--pagination--previous": tag,
        children: formatMessage('previous')
      }), pagesEls, /*#__PURE__*/jsx(Button, {
        iconOnly: isIconOnly,
        actionIndicator: "MdNavigateNext",
        variant: buttonVariant,
        size: "small",
        disabled: isLoading || page === pageCount - 1,
        onClick: e => {
          e.preventDefault();
          if (page < pageCount - 1) {
            onPageChange(page + 1);
          }
        },
        "data-dsx--pagination--next": tag,
        children: formatMessage('next')
      })]
    }), summaryEl]
  });
}
function pageRange(page, pageCount, layout) {
  if (layout === 'nav-only') {
    return [];
  }
  const lastPage = pageCount - 1;
  if (layout === '7-slot') {
    if (pageCount <= 7) {
      return range(0, lastPage);
    }
    if (page <= 1 || page >= lastPage - 1) {
      return [...range(0, 2), '...', ...range(lastPage - 2, lastPage)];
    }
    return [0, '...', ...range(page - 1, page + 1), '...', lastPage];
  }
  if (pageCount <= 9) {
    return range(0, lastPage);
  }
  if (page <= 1 || page >= pageCount - 2) {
    return [...range(0, 3), '...', ...range(pageCount - 4, lastPage)];
  }
  if (page <= 4) {
    return [...range(0, page + 2), '...', ...range(pageCount + page - 5, lastPage)];
  }
  if (page >= pageCount - 5) {
    return [...range(0, page - pageCount + 5), '...', ...range(page - 2, lastPage)];
  }
  return [0, '...', ...range(page - 2, page + 2), '...', lastPage];
}
function range(from, to) {
  return Array(to - from + 1).fill(undefined).map((_, n) => n + from);
}

export { Pagination };
